import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=171cb467&scoped=true"
import script from "./menuList?vue&type=script&lang=js&external"
export * from "./menuList?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171cb467",
  null
  
)

export default component.exports